import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { commonShowAlert, Dictionary } from '../lib';
import qs from 'qs';

interface UseSearchMetadataProps {
    terms: string[];
    queryProps?: any;
}

const getQueryData = async (
    url: string,
    terms: string[],
    token: string
): Promise<AxiosResponse<Dictionary[], any>> => {
    const headers = getDefaultHeaders(token);

    return axiosInstance().get(url, {
        ...withHeaders(headers),
        params: { terms: terms },
        paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: 'repeat' }),
    });
};

export const useSearchMetadata = (
    props: UseSearchMetadataProps
): UseQueryResult<AxiosResponse<any[], any>, unknown> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const { terms, queryProps } = props;

    return useQuery(
        ['metadata-search', terms],
        async () => getQueryData('/metadata/search', terms, getToken()),
        {
            ...queryProps,
            enabled: false,
            onError: (error: any) => {
                const errorMessage: string =
                    'System error. Please enter new search criteria below.';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
